module.exports = __webpack_public_path__ + "img/skiing.be5030ca.webp";